import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import Games from './pages/Games';
import Schedule from './pages/Schedule';
import Login from './pages/Login';
import Register from './pages/Register';
import ChartPage from './pages/ChartPage';
import GameTypesPage from './pages/GameTypesPage';
import BettingPage from './pages/BettingPage';
import BetHistoryPage from './pages/BetHistoryPage';
import Deposit from './pages/Deposit';
import Withdraw from './pages/Withdraw';
import BankDetails from './pages/BankDetails';
import WithdrawHistory from './pages/WithdrawHistory';
import ChangePassword from './pages/ChangePassword';
import AccountStatement from './pages/AccountStatement';
import ContactUs from './pages/ContactUs';
import ForgotPassword from './pages/ForgotPassword';
import VerifyOtp from './pages/VerifyOtp';
import ChangePasswordbeforelogin from './pages/changepasswordbeforelogin';
import './App.css';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on every route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

// Main Layout Component for all protected routes
const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="main-container">
        <Sidebar />
        <main className="main-content">
          {children}
        </main>
      </div>
    </>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop /> {/* Add scroll to top component */}
        <Toaster position="top-right" />
        <div className="app">
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/change-password-before" element={<ChangePasswordbeforelogin />} />

            {/* Chart Page - Special layout without sidebar */}
            <Route path="/chart" element={
              <ProtectedRoute>
                <ChartPage />
              </ProtectedRoute>
            } />
            
            {/* All other protected routes with MainLayout */}
            <Route path="/" element={
              <ProtectedRoute>
                <MainLayout>
                  <Home />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/games" element={
              <ProtectedRoute>
                <MainLayout>
                  <Games />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/schedule" element={
              <ProtectedRoute>
                <MainLayout>
                  <Schedule />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/game-types" element={
              <ProtectedRoute>
                <MainLayout>
                  <GameTypesPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/bet/:gameId/:gameType" element={
              <ProtectedRoute>
                <MainLayout>
                  <BettingPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/bet" element={
              <ProtectedRoute>
                <MainLayout>
                  <BettingPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/bet-history" element={
              <ProtectedRoute>
                <MainLayout>
                  <BetHistoryPage />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/deposit" element={
              <ProtectedRoute>
                <MainLayout>
                  <Deposit />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/withdraw" element={
              <ProtectedRoute>
                <MainLayout>
                  <Withdraw />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/bank-details" element={
              <ProtectedRoute>
                <MainLayout>
                  <BankDetails />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/withdraw-history" element={
              <ProtectedRoute>
                <MainLayout>
                  <WithdrawHistory />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/change-password" element={
              <ProtectedRoute>
                <MainLayout>
                  <ChangePassword />
                </MainLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/account-statement" element={
              <ProtectedRoute>
                <MainLayout>
                  <AccountStatement />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/contact-us" element={
              <ProtectedRoute>
                <MainLayout>
                  <ContactUs />
                </MainLayout>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;